<div *ngIf="purchaseItemData" class="mct-gap-16 mct-grid-gt-sm mct-cols-1-1-gt-sm">
  <div class="mct-flex mct-col mct-gap-5 mt-16">
    <label>{{ 'form-builder.legos.purchase-item.revenue-item' | translate | ucfirst }}</label>
    <p-select
      [placeholder]="'form-builder.legos.purchase-item.select-a-revenue-item' | translate | ucfirst"
      name="RevenueItemNum"
      [options]="revenueItemOptions"
      [(ngModel)]="purchaseItemData.RevenueItemNum"
      appendTo="body"
      [style]="{ width: '100%' }"
      (onChange)="revenueItemChanged()"
      [required]="true"
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
      <p-checkbox name="UseArc" [(ngModel)]="purchaseItemData.UseArc" [binary]="true" [disabled]="useArcDisabled" inputId="useArc">
      </p-checkbox>
      <label for="useArc">
        {{ 'form-builder.legos.purchase-item.use-arc' | translate | ucfirst }}
      </label>
    </div>
    <div *ngIf="purchaseItemData.UseArc && revenueItemArcOptions?.length > 1">
      <p-select
        [placeholder]="'form-builder.legos.purchase-item.select-an-arc' | translate | ucfirst"
        name="Arc"
        [options]="revenueItemArcOptions"
        [(ngModel)]="purchaseItemData.ArcId"
        appendTo="body"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
      <p-checkbox name="UseArb" [(ngModel)]="purchaseItemData.UseArb" [binary]="true" [disabled]="useArbDisabled" inputId="useArb">
      </p-checkbox>
      <label for="useArb">
        {{ 'form-builder.legos.purchase-item.use-arb' | translate | ucfirst }}
      </label>
    </div>
    <div *ngIf="purchaseItemData.UseArb">
      <p-select
        [placeholder]="'form-builder.legos.purchase-item.select-billing-cycle' | translate | ucfirst"
        [required]="purchaseItemData.UseArb"
        name="Arc"
        [options]="revenueItemArbOptions"
        [(ngModel)]="purchaseItemData.BillingCycle"
        appendTo="body"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
  </div>
  <div class="mt-16">
    <label>{{ 'form-builder.legos.display-name' | translate | ucfirst }}</label>
    <input name="itemName" [(ngModel)]="purchaseItemData.RevenueItemName" class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16">
    <label>{{ 'form-builder.legos.purchase-item.price' | translate | ucfirst }}</label>
    <input name="Price" [(ngModel)]="purchaseItemData.Price" class="form-control" type="number" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-col-start-1 mt-16">
    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
      <p-checkbox name="AllowCustomAmount" [(ngModel)]="purchaseItemData.AllowCustomAmmount" [binary]="true" inputId="allowCustomAmount">
      </p-checkbox>
      <label for="allowCustomAmount">
        {{ 'form-builder.legos.purchase-item.allow-custom-amount' | translate | ucfirst }}
      </label>
    </div>
  </div>
  <div>
    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4 mt-16">
      <p-checkbox name="Required" [(ngModel)]="purchaseItemData.Required" [binary]="true" inputId="requiredCheckbox"> </p-checkbox>
      <label for="requiredCheckbox">
        {{ 'common.required' | translate | titlecase }}
      </label>
    </div>
  </div>
</div>
